import Vue from 'vue'

import RenderFile from './components/RenderImg'

if (document.querySelector('#main-isotope')) {
  new Vue({
    el: '#main-isotope',
    components: {
      'render-file-daily': RenderFile,
    },
  })
}
